var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    fill: "#4F0259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), ">", title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tArtboard 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.81,147.35a217.3,217.3,0,0,0,79.54,296.83,13,13,0,1,0,13-22.52A191.29,191.29,0,0,1,243.56,65.11l-16.1,16.1A13,13,0,1,0,245.84,99.6l38.7-38.7a13,13,0,0,0,0-18.38l-38.7-38.7a13,13,0,0,0-18.38,18.38L244.29,39A217.26,217.26,0,0,0,67.81,147.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.65,421.67a191.59,191.59,0,0,1-83.21,25.22l16.1-16.1a13,13,0,1,0-18.38-18.38l-38.7,38.7a13,13,0,0,0,0,18.38l38.7,38.7a13,13,0,1,0,18.38-18.38L267.71,473A217.29,217.29,0,0,0,364.65,67.81a13,13,0,0,0-13,22.52,191.3,191.3,0,0,1,0,331.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269,161.38V147.24a13,13,0,0,0-26,0v13.95c-26.56,5.24-45.31,26.39-45.31,53.27,0,15.46,7.15,43,54.9,54.09l.48.12c35.21,8,35.21,23.72,35.21,28.87,0,19.6-16.75,28.53-32.31,28.53a32.26,32.26,0,0,1-29.82-19.83,13,13,0,1,0-24,10.06A58.19,58.19,0,0,0,243,350.63v14.13a13,13,0,0,0,26,0v-14c26.55-5.25,45.28-26.39,45.28-53.26,0-15.46-7.15-43-54.9-54.09l-.48-.12c-35.21-8-35.21-23.72-35.21-28.87,0-19.6,16.75-28.53,32.31-28.53a32.27,32.27,0,0,1,29.82,19.83,13,13,0,1,0,24-10.06A58.19,58.19,0,0,0,269,161.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.459ac0b26d3e9b160c8c8165ba11a906.svg";
export { ForwardRef as ReactComponent };